module.exports = "/_next/static/images/dropbox-715a27fd7d5a81e93d2bd34bb6fc7ebb.svg";